import React, { useState, useEffect } from 'react';
import SplashScreen from './components/SplashScreen';
import WelcomeSlides from './components/WelcomeSlides';
import AuthPage from './components/AuthPage';
import EnrollmentFlow from './components/EnrollmentFlow';
import MainApp from './components/MainApp';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './hooks/useAuth';

function AppContent() {
  const [isLoading, setIsLoading] = useState(true);
  const [hasSeenWelcome, setHasSeenWelcome] = useState(false);
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Check if user has seen welcome slides
    const seenWelcome = localStorage.getItem('hasSeenWelcome');
    if (seenWelcome === 'true') {
      setHasSeenWelcome(true);
    }
  }, []);

  const handleWelcomeComplete = () => {
    setHasSeenWelcome(true);
    localStorage.setItem('hasSeenWelcome', 'true');
  };

  if (isLoading) {
    return <SplashScreen />;
  }

  if (!hasSeenWelcome) {
    return <WelcomeSlides onComplete={handleWelcomeComplete} />;
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  if (isAuthenticated && !user?.isEnrolled) {
    return <EnrollmentFlow />;
  }

  return <MainApp />;
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
